import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center" data-testid="protected-loading">
                <div className="w-10 h-10 rounded-full border-2 border-[var(--ns-border)] border-t-[var(--ns-clay)] animate-spin" />
            </div>
        );
    }
    if (!user) {
        const target = `${location.pathname}${location.search}` || '/dashboard';
        const qs = target !== '/dashboard' ? `?redirect=${encodeURIComponent(target)}` : '';
        return <Navigate to={`/login${qs}`} replace />;
    }
    return children;
};

export default ProtectedRoute;
